var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgBenefits4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3027 42.1134L31.1956 11.0449L32.9942 5.64922C33.47 4.22158 33.2959 2.78262 32.5165 1.70127C31.7371 0.620117 30.4271 0 28.9224 0H21.0775C19.5725 0 18.2625 0.620312 17.483 1.70166C16.7038 2.78301 16.5297 4.22197 17.0056 5.64932L18.8043 11.0449L15.6972 42.1134C15.6478 42.6074 15.8521 43.0928 16.2397 43.4029L24.0848 49.679C24.3524 49.893 24.6762 50 25 50C25.3237 50 25.6475 49.893 25.9151 49.679L33.7602 43.4029C34.1478 43.0929 34.3521 42.6074 34.3027 42.1134Z",
    fill: "#FF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3027 42.1134L31.1955 11.0449L32.9942 5.64922C33.4699 4.22158 33.2958 2.78262 32.5164 1.70127C31.737 0.620117 30.4271 0 28.9224 0H24.9987V49.9999C24.999 49.9999 24.9995 50 24.9999 50C25.3237 50 25.6475 49.893 25.9151 49.679L33.7602 43.4029C34.1478 43.0929 34.3521 42.6074 34.3027 42.1134Z",
    fill: "#FF0059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1956 11.0449L31.7392 9.41415H18.2607L18.8044 11.0449L18.6744 12.3438H31.3256L31.1956 11.0449Z",
    fill: "#E7F0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1955 11.0449L31.7392 9.41415H24.9987V12.3438H31.3255L31.1955 11.0449Z",
    fill: "#C5E1E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBenefits4);
export default __webpack_public_path__ + "static/media/imgBenefits4.a34ec7ae35b4ece721904871fe561645.svg";
export { ForwardRef as ReactComponent };